export default __webpack_public_path__ + "static/bottom-65db5257eb12059c66fec36b8d346d53.png";